import React from 'react';
import parse from 'html-react-parser';
import { useState,useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASEURL;

function SpecialPage (props){

        const[marginLeft, setMarginLeft] = useState (100)
        const[marginRight, setMarginRight] = useState (100)
        
        const[pageContent, setPageContent] = useState("Getting Page Info For You!... ")

        const titleStyle = () => ({
            marginLeft: marginLeft,
            marginRight: marginRight,
            fontSize: 18,
            fontWeight: 'bold'
        });

        const contentStyle = () => ({
            marginLeft: marginLeft,
            marginRight: marginRight,
        });

        useEffect(() => {
            getContext();
            }, [props.page]);

        const getContext = () => {
            // console.log("Here is the page you are sending in your API Call: ",props.page);
            axios.get(apiUrl + `/api/Page/GetContent?page=${props.page}`, {
            })
            .then((response) => {
            //   console.log("get context response data:", response.data);
              const context = (response.data); // Make sure response.data is an array
              setPageContent(context.pageContent);
              setMarginLeft(context.marginLeft);
              setMarginRight(context.marginRight);
            })
            .catch((error) => {
              console.log(error);
            });
            };

        return (
            <div className = "flex-col fill">
                <h1 className = "flex-row center">{props.page}</h1>
                <p style={titleStyle()}></p>
                <p style={contentStyle()}>{parse(pageContent) || ''}</p>                    
            </div>
        );
    }


export default SpecialPage;